export default "__VITE_PUBLIC_ASSET__69efa063__"